var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9C15 5.70968 12.2903 3 9 3C5.68548 3 3 5.70968 3 9C3 12.3145 5.68548 15 9 15C12.2903 15 15 12.3145 15 9ZM8.29839 12.1935C8.15323 12.3387 7.8871 12.3387 7.74194 12.1935L5.22581 9.67742C5.08065 9.53226 5.08065 9.26613 5.22581 9.12097L5.78226 8.58871C5.92742 8.41935 6.16935 8.41935 6.31452 8.58871L8.03226 10.2823L11.6613 6.65323C11.8065 6.48387 12.0484 6.48387 12.1935 6.65323L12.75 7.18548C12.8952 7.33065 12.8952 7.59677 12.75 7.74194L8.29839 12.1935Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.2a3fe954beba790a9419dfade6e5bdc8.svg";
export { ForwardRef as ReactComponent };